import { useEffect, useState } from "react";

export default function useTableFilters(storageKey, defaultFilters) {
  const [filters, setFilters] = useState(defaultFilters);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const saved = sessionStorage.getItem(storageKey);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.dateRangeType === "custom") {
          setFilters({
            ...defaultFilters,
            ...parsed,
            customDateRange: null,
            dateRangeType: defaultFilters.dateRangeType,
          });
        } else {
          setFilters({ ...defaultFilters, ...parsed });
        }
      } catch {
        /* ignore */
      }
    }
    setHydrated(true);
  }, [storageKey]);

  useEffect(() => {
    if (!hydrated) return;
    sessionStorage.setItem(storageKey, JSON.stringify(filters));
  }, [filters, hydrated, storageKey]);

  return { filters, setFilters, hydrated };
}
